import {
  parseAsString,
  useQueryStates,
  type HistoryOptions,
} from '@vrplatform/query-params';
import { removeDrawerStateFromUrl } from '../../../utils';

type View = 'overview' | 'edit' | 'record-ownership';

export function useListingDetailDrawer() {
  const [opts, set] = useQueryStates({
    listing: parseAsString,
    view: parseAsString,
  });

  return {
    opened: !!opts.listing,
    open: (id: string, view?: View, updateType?: HistoryOptions) => {
      removeDrawerStateFromUrl();
      set({ listing: id, view }, { history: updateType || 'push' });
    },
    close: () => set(null),
    listingId: opts.listing,
    view: (opts.view || 'overview') as View,
    setView: (view: View) => set({ view }),
  };
}
